import React, { useEffect } from "react";
import loginImage from "../../assets/images/GovCo.png";
import styles from "./govCo.module.css";

// Declaración global para que TypeScript reconozca window.initChatbot
declare global {
  interface Window {
    initChatbot?: (containerId: string, options?: Record<string, any>) => void;
  }
}

const GovCoPage: React.FC = () => {
  useEffect(() => {
    // Cargar CSS del chatbot si no está presente
    const linkId = "chatbot-widget-style";
    if (!document.getElementById(linkId)) {
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = "https://widget-assistant-test.kamilainnovation.co/chatbot-widget.css";
      document.head.appendChild(link);
    }

    // Cargar script del chatbot si no está presente
    const scriptId = "chatbot-widget-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://widget-assistant-test.kamilainnovation.co/widget.umd.js";
      script.async = true;
      script.onload = () => {
        window.initChatbot?.("root-widget", {
          userName: "Visitante Gov.co",
        widgetId:'ceb1594e-4616-4665-b375-92594599e9a1'

        });
      };
      document.body.appendChild(script);
    } else {
      // Si ya está cargado, inicializar directamente
      window.initChatbot?.("root-widget", {
        userName: "Visitante Gov.co",
        widgetId:'ceb1594e-4616-4665-b375-92594599e9a1'
      });
    }

    // Limpieza al desmontar el componente
    return () => {
      const widgetDiv = document.getElementById("root-widget");
      if (widgetDiv) widgetDiv.innerHTML = "";
    };
  }, []);

  return (
    <div className={styles.fullscreen}>
      {/* <img src={loginImage} alt="Fondo" className={styles.bgImage} /> */}
      <iframe src="https://portal.kamilainnovation.com.co/" style={{height:'100vh'}}/>
      <div id="root-widget" />
    </div>
  );
};

export default GovCoPage;
